export const ENDPOINT_ACCOUNT_API =
  process.env.ENDPOINT_ACCOUNT_API ?? 'https://api.tuicruises.com';

// This is used for "force production" clients.
// Clients, which should by default access production in any environment.
// Therefore, you should not use this publicly, or make it configurable.
export const API_KIT_ONLY_ENDPOINT_ACCOUNT_API_PROD =
  'https://api.tuicruises.com';

export const ENDPOINT_ACCOUNT_API_TIMEOUT = parseInt(
  process.env.ENDPOINT_ACCOUNT_API_TIMEOUT ?? '30000',
  10,
);

export const ENDPOINT_CMW_API =
  process.env.ENDPOINT_CMW_API ?? 'https://cmware.meinschiff.com/ws';

export const ENDPOINT_CMW_BASIC_AUTH_USER =
  process.env.ENDPOINT_CMW_BASIC_AUTH_USER ?? 'react';

export const ENDPOINT_CMW_BASIC_AUTH_PASSWORD =
  process.env.ENDPOINT_CMW_BASIC_AUTH_PASSWORD ?? 'nextjs';

export const ENDPOINT_OSS_API =
  process.env.ENDPOINT_OSS_API ?? 'https://api.tuicruises.com/oss';

export const ENDPOINT_OSS_API_TIMEOUT = parseInt(
  process.env.ENDPOINT_OSS_API_TIMEOUT ?? '2000',
  10,
);

export const ENDPOINT_PCL_API =
  process.env.ENDPOINT_PCL_API ?? 'https://api.tuicruises.com/pcl';

export const ENDPOINT_PCL_API_TIMEOUT = parseInt(
  process.env.ENDPOINT_PCL_API_TIMEOUT ?? '2000',
  10,
);

export const ENDPOINT_MPS_API =
  process.env.ENDPOINT_MPS_API ?? 'https://api.tuicruises.com/mps';

export const ENDPOINT_MPS_API_TIMEOUT = parseInt(
  process.env.ENDPOINT_MPS_API_TIMEOUT ?? '2000',
  10,
);

export const ENDPOINT_AUTH_CLIENT_CREDENTIALS_URL =
  'https://api.tuicruises.com/auth/token?grant_type=client_credentials';

export const ENDPOINT_AUTH_CREDENTIALS =
  process.env.ENDPOINT_AUTH_CREDENTIALS ??
  '3j6t7ocouf08o24a1l006e90lm:1r0l6uucl6uol9nqlq9qclmm1ee0slsfu5l9n0ieroffevg1njdv';

export const ENDPOINT_UIS_API =
  process.env.ENDPOINT_UIS_API ?? 'https://api.tuicruises.com/user-information';

export const ENDPOINT_UIS_API_KEY =
  process.env.ENDPOINT_UIS_API_KEY ??
  'jIQaJUACnN9HOc4ERjihG2hn2OAGLpTl4Tao4TRI';

export const ENDPOINT_UIS_API_TIMEOUT = parseInt(
  process.env.ENDPOINT_UIS_API_TIMEOUT ?? '2000',
  10,
);

export const ENDPOINT_BOOKINGHUB_API =
  process.env.ENDPOINT_BOOKINGHUB_API ??
  'https://api.tuicruises.com/booking-hub';

export const ENDPOINT_BOOKINGHUB_API_TIMEOUT = parseInt(
  process.env.ENDPOINT_BOOKINGHUB_API_TIMEOUT ?? '1000',
  10,
);
